export default "/images/pergamumAlto.svg?ec1d91ef8912bfddb5bcf24857ad20d4";